import _ from 'lodash';
import { createSelector } from 'reselect';

var getAllSetsAsObject = function getAllSetsAsObject(state) {
  return state.windows.sets;
};

var getAllWindowsAsObject = function getAllWindowsAsObject(state) {
  return state.windows.windows;
};

var getSetByKey = createSelector([getAllSetsAsObject, function (state, key) {
  return key;
}], function (sets, key) {
  return sets && sets[key];
});
var getWindow = createSelector([getAllWindowsAsObject, function (state, key) {
  return key;
}], function (windows, key) {
  return windows && windows[key];
});
var getWindowsBySetKeyAsObject = createSelector([getSetByKey, getAllWindowsAsObject], function (set, windows) {
  if (set && set.orderByHistory && set.orderByHistory.length) {
    var setWindows = {};

    _.each(set.orderByHistory, function (key) {
      setWindows[key] = windows[key];
    });

    return setWindows;
  } else {
    return null;
  }
});
var isOpen = createSelector([getWindow], function (window) {
  return window && window.data && window.data.state === 'open';
});
export default {
  getSetByKey: getSetByKey,
  getWindow: getWindow,
  getWindowsBySetKeyAsObject: getWindowsBySetKeyAsObject,
  isOpen: isOpen
};